import { interpretStatuses } from './statuses.mjs';
import { processData } from './process-data.mjs';
import { addDates } from './dates.mjs';
import { initModal } from './abstract-dialog.mjs';
import { addSpeakerList } from './speaker-list.mjs';
import { addLightningTable } from './lightning-table.mjs';
import { addTimetable } from './timetable.mjs';
import { addPricing } from './pricing.mjs';
import { addFaqs } from './faqs.mjs';


async function fetchJson(fName) {
  try {
    const url = `/data/${fName}.json`;
    const raw = await fetch(url);
    const data = await raw.json();
    return data;
  }
  catch(e) {
    console.error(e);
    return {};
  }
}


async function home() {
  const sources = ['statuses', 'dates', 'talks', 'timetable', 'pricing', 'socials'];
  const data = await Promise.all(sources.map(f => fetchJson(f)));
  const [statuses, dates, rawTalks, rawTimetable, pricing, socials] = data;
  const { talks, timetable } = processData(dates, rawTalks, rawTimetable, socials);

  interpretStatuses(statuses);
  addDates(dates);
  initModal(talks);
  addPricing(pricing);
  addTimetable(timetable, talks);
  addSpeakerList(talks);
  addLightningTable(talks);
}


async function speakerFaq() {
  const sources = ['faqs', 'dates'];
  const data = await Promise.all(sources.map(f => fetchJson(f)));
  const [ faqs, dates ] = data;
  addFaqs(faqs);
  addDates(dates);
}


async function main() {
  const page = document.documentElement.dataset.page;

  try {
    if (page === 'home') { await home(); }
    else if (page === 'speaker-faq') { await speakerFaq(); }
  }
  catch(e) {
    console.error(e);
  }
  finally {
    if (location.hash) {
      const target = document.querySelector(location.hash);
      target?.scrollIntoView();
    }
    document.body.removeAttribute('data-loading');
  }
}

main();
